(function(){
  'use strict';

  var MAX_ATTEMPTS = 40;
  var ATTEMPT_INTERVAL = 200; // ms between polls
  var attempt = 0;
  var DEBUG = true; // خلي false لو مش عايزة لوجات في الكونسل

  function debugLog() { if (!DEBUG) return; console.log.apply(console, arguments); }
  function debugWarn(){ if (!DEBUG) return; console.warn.apply(console, arguments); }

  function detectRTL() {
    var html = document.documentElement;
    var body = document.body;
    return (html && html.getAttribute && html.getAttribute('dir') === 'rtl')
      || (body && body.getAttribute && body.getAttribute('dir') === 'rtl')
      || (body && body.classList && body.classList.contains('rtl'))
      || (html && html.classList && html.classList.contains('rtl'));
  }

  function parseOptionsFromElement(el) {
    var opts = {};
    var attr = el.getAttribute('data-flickity-options') || el.getAttribute('data-flickity');
    if (attr) {
      try {
        opts = JSON.parse(attr);
      } catch (e) {
        // sometimes it's JS-obj-like, try safe eval
        try {
          opts = Function('return (' + attr + ')')();
        } catch (e2) {
          // ignore
        }
      }
    }
    return opts;
  }

  function ensureFlickityReady(cb) {
    if (typeof Flickity !== 'undefined') {
      cb && cb();
      return;
    }
    attempt++;
    if (attempt > MAX_ATTEMPTS) {
      debugWarn('custom-slider: Flickity not found after', MAX_ATTEMPTS, 'attempts.');
      return;
    }
    setTimeout(function(){
      ensureFlickityReady(cb);
    }, ATTEMPT_INTERVAL);
  }

  function createOrUpdateSlider(sliderEl, isRTL) {
    try {
      if (typeof Flickity === 'undefined') {
        return;
      }
      var instance = Flickity.data(sliderEl);

      if (instance) {
        var currentRTL = !!instance.options.rightToLeft;
        if (currentRTL !== isRTL) {
          // preserve previous options as best as possible
          var prevOpts = Object.assign({}, instance.options || {});
          prevOpts.rightToLeft = isRTL;

          // destroy and recreate to ensure direction applied correctly
          try { instance.destroy(); } catch (e){ debugWarn('custom-slider: destroy failed', e); }

          try {
            new Flickity(sliderEl, prevOpts);
            debugLog('custom-slider: re-initialized slider to', isRTL ? 'RTL' : 'LTR', sliderEl);
          } catch (e) {
            debugWarn('custom-slider: failed re-init', e);
          }
        } else {
          // already correct direction -> ensure layout updated
          try { instance.resize && instance.resize(); } catch(e){}
        }
      } else {
        // not initialized yet -> try to parse options from element
        var opts = parseOptionsFromElement(sliderEl);
        opts = Object.assign({ contain: true, pageDots: true, cellAlign: 'left' }, opts);
        opts.rightToLeft = isRTL;

        try {
          new Flickity(sliderEl, opts);
          debugLog('custom-slider: initialized slider', sliderEl);
        } catch (e) {
          debugWarn('custom-slider: failed to init new Flickity', e);
        }
      }
    } catch (err) {
      debugWarn('custom-slider: createOrUpdateSlider error', err);
    }
  }

  function updateAllSliders(){
    var isRTL = detectRTL();
    var sliders = document.querySelectorAll('.flickityt4s-slider');
    if(!sliders || sliders.length === 0) {
      debugLog('custom-slider: no sliders found');
      return;
    }
    sliders.forEach(function(slider){
      createOrUpdateSlider(slider, isRTL);
    });
  }

  // start after DOM ready, then wait for Flickity if needed
  function start() {
    ensureFlickityReady(updateAllSliders);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // observe <html dir> changes to update direction live
  (function(){
    var html = document.documentElement;
    if (!html) return;
    var last = html.getAttribute('dir');
    var mo = new MutationObserver(function(muts){
      muts.forEach(function(m){
        if (m.type === 'attributes' && m.attributeName === 'dir') {
          var now = html.getAttribute('dir');
          if (now !== last) {
            last = now;
            debugLog('custom-slider: html dir changed ->', now);
            ensureFlickityReady(updateAllSliders);
          }
        }
      });
    });
    mo.observe(html, { attributes: true });
  })();

  // observe DOM for newly added sliders (AJAX, language switcher partials, etc.)
  (function(){
    if (!document.body) return;
    var bodyMo = new MutationObserver(function(muts){
      muts.forEach(function(m){
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach(function(node){
            if (node.nodeType !== 1) return;
            if (node.classList && node.classList.contains('flickityt4s-slider')) {
              ensureFlickityReady(updateAllSliders);
            } else if (node.querySelector && node.querySelector('.flickityt4s-slider')) {
              ensureFlickityReady(updateAllSliders);
            }
          });
        }
      });
    });
    bodyMo.observe(document.body, { childList: true, subtree: true });
  })();

})();
